export enum IndividualAssetEvents {
  CLICKED_SHOW_MORE_OR_LESS = 'INDIVIDUAL_ASSET:clicked_show_more_or_less',
  CLICKED_NEWS_ITEM = 'INDIVIDUAL_ASSET:clicked_news_item',
  CLICKED_RELATED_ASSET = 'INDIVIDUAL_ASSET:clicked_related_asset',
  SWITCH_GRAPH_PERIOD = 'INDIVIDUAL_ASSET:switch_graph_period',
  CLICKED_PENDING_SCHEDULED_ORDER = 'INDIVIDUAL_ASSET:clicked_pending_scheduled_order',
  CLICKED_PENDING_ORDER_REQUEST = 'INDIVIDUAL_ASSET:clicked_pending_order_request',
}
